module.exports = __webpack_public_path__ + "static/media/Close.1b2e83db.png";